<a class="block full_height" [routerLink]="routerService.PRODUCT +'/'+ product.id" [attr.aria-label]="ariaLabel">
	<mat-card class="mat_card_hover pink_shadow flex full_height relative" [ngClass]="{own_publication: product.store_id && loggedUserStoreId == product.store_id}">
		<image-in-aspect-ratio
			[img_src]="product.photo"
			[aspect_ratio]="66.66"
			[wrapper_classes]="'bg_primary_500'"
		></image-in-aspect-ratio>
	
		<mat-card-content class="flex flex_column flex1 align_items_space_between">
			
			<div class="flex1">
				<ng-container *ngIf="product.product_discount[0]; else noDiscount">
					<div class="justify_content_space_between">
						<p class="strikethrough body2 color_black_inactive fw500">{{ product.amount | properCurrencyPipe }}</p>
						<!--
						En desuso temporalmente. No hay flow de calificación de productos
						<div class="rating align_items_center" *ngIf="product.rating">
							<p class="body2 inline_block fw500 color_black_medium_emphasis">{{ product.rating }}</p>
							<img src="/assets/img/icons/star.svg" class="inline_block">
						</div>
						-->
					</div>
		
					<div class="flex_wrap align_items_center">
						<h3 class="h3point5 fw400 margin_right_very_small">{{ product.priceAfterDiscount | properCurrencyPipe }}&nbsp;</h3>
						<p class="body2 fw500 color_primary_700">{{ product.product_discount[0].amount | number:"1.0-2" }}% OFF</p>
					</div>
				</ng-container>
				<ng-template #noDiscount>
					<div class="flex_wrap justify_content_space_between">
						<div class="align_items_flex_start">	<!--	 [ngClass]="{align_items_center: product.rating, align_items_flex_start: !product.rating}"	-->
							<h3 class="h3point5 fw400 margin_right_very_small">{{ product.amount | properCurrencyPipe }}</h3>
						</div>
		
						<!--
						En desuso temporalmente. No hay flow de calificación de productos
						<div class="rating align_items_center" *ngIf="product.rating">
							<p class="body2 inline_block fw500 color_black_medium_emphasis">{{ product.rating | number:"1.0-2" }}</p>
							<img src="/assets/img/icons/star.svg" class="inline_block">
						</div>
						-->
					</div>
				</ng-template>
	
				<p class="line3 fw500 body1">{{ product.title }}</p>
			</div>
	
			<div class="line4">		<!-- Todos los productos tienen valuables -->
				<img *ngFor="let v of product.valuables" [src]="values[v-1].imgSrcBlue" [matTooltip]="values[v-1].title">
			</div>
			
		</mat-card-content>

		<div *ngIf="product.store_id && loggedUserStoreId == product.store_id" class="product_is_mine_corner" [matTooltip]="'Esta publicación es tuya'" matTooltipPosition="above">
			<app-avatar [size]="'32px'"></app-avatar>
		</div>
	</mat-card>
</a>